export default __webpack_public_path__ + "static/media/WhyTTMIK.45a18438.png";